import { render, staticRenderFns } from "./ModalDirectWhatsApp.vue?vue&type=template&id=c63b87a0&scoped=true&"
import script from "./ModalDirectWhatsApp.vue?vue&type=script&lang=js&"
export * from "./ModalDirectWhatsApp.vue?vue&type=script&lang=js&"
import style0 from "./ModalDirectWhatsApp.vue?vue&type=style&index=0&id=c63b87a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63b87a0",
  null
  
)

export default component.exports